import { getResponsiveProp, rem, responsive } from '../helpers';
export function responsiveInputPaddingStyle(props) {
  var iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      theme = props.theme;
  var padding = getResponsiveProp(props.padding, [0]);
  var space = getResponsiveProp(props.space, [0]);
  var size = getResponsiveProp(props.uiSize, [0]);
  var len = Math.max(padding.length, space.length, size.length);
  var _padding = [];
  var _space = [];
  var _size = [];

  for (var i = 0; i < len; i += 1) {
    _padding[i] = padding[i] === undefined ? _padding[i - 1] : padding[i];
    _space[i] = space[i] === undefined ? _space[i - 1] : space[i];
    _size[i] = size[i] === undefined ? _size[i - 1] : size[i];
  }

  return responsive(theme.sanity.media, _padding.map(function (_, i) {
    var fontSize = theme.sanity.fonts.text.sizes[_size[i]] || theme.sanity.fonts.text.sizes[2];
    var emSize = fontSize.lineHeight - fontSize.ascenderHeight - fontSize.descenderHeight;
    var p = theme.sanity.space[_padding[i]];
    var s = theme.sanity.space[_space[i]];
    var styles = {
      paddingTop: rem(p - fontSize.ascenderHeight),
      paddingRight: rem(p),
      paddingBottom: rem(p - fontSize.descenderHeight),
      paddingLeft: rem(p)
    };
    if (iconRight) styles.paddingRight = rem(p + emSize + s);
    if (iconLeft) styles.paddingLeft = rem(p + emSize + s);
    return styles;
  }));
}
export function responsiveInputPaddingIconsStyle(props) {
  return responsiveInputPaddingStyle(Object.assign(Object.assign({}, props), {
    iconLeft: true,
    iconRight: true
  }));
}
export function responsiveInputPaddingIconLeftStyle(props) {
  return responsiveInputPaddingStyle(Object.assign(Object.assign({}, props), {
    iconLeft: true
  }));
}
export function responsiveInputPaddingIconRightStyle(props) {
  return responsiveInputPaddingStyle(Object.assign(Object.assign({}, props), {
    iconRight: true
  }));
}